import React from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery, Typography } from '@mui/material';
import warehouseImage from '../assets/warehouse.png';

const Warehouse = () => {
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:800px)');

    // Função que redireciona para /warehouseop com a opção selecionada
    const handleClick = (option) => {
        navigate('/warehouseop', { state: { selectedOption: option } });
    };

    const footer = (
        <div 
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '1rem',
                margin: '2rem 0'
            }}
        >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Button 
                    icon="pi pi-sign-in" 
                    className="p-button-primary" 
                    onClick={() => handleClick('entrada')} 
                />
                <Typography variant="caption">Entrada</Typography>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Button 
                    icon="pi pi-sign-out" 
                    className="p-button-secondary" 
                    onClick={() => handleClick('saida')} 
                />
                <Typography variant="caption">Saída</Typography>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Button 
                    icon="pi pi-box" 
                    className="p-button-info" 
                    onClick={() => handleClick('mercadorias')} 
                />
                <Typography variant="caption">Mercadorias</Typography>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Button 
                    icon="pi pi-user" 
                    className="p-button-success" 
                    onClick={() => handleClick('gestor')} 
                />
                <Typography variant="caption">Gestor</Typography>
            </div>
        </div>
    );

    return (
        <div
            style={{
                minHeight: '100vh',
                backgroundImage: `url(${warehouseImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2rem'
            }}
        >
            <Card 
                title="Warehouse" 
                footer={footer} 
                style={{ 
                    width: isMobile ? '90%' : '40%', 
                    minWidth: isMobile ? '280px' : '300px', 
                    boxShadow: '0 4px 8px rgba(0,0,0,0.2)' 
                }}
            >
                <p style={{ textAlign: 'center' }}>
                    Bem Vindo de volta
                </p>
            </Card>
        </div>
    );
};

export default Warehouse;
